import { CostsPeriod } from './costs-period';
import { PeriodShortcut } from './period-shortcut';

/** Os atalhos oferecidos na barra, na ordem em que aparecem. */
export class PeriodShortcuts {
  private static readonly ALL: ReadonlyArray<PeriodShortcut> = [
    new PeriodShortcut('hoje', () => CostsPeriod.lastDays(1)),
    new PeriodShortcut('ontem', () => CostsPeriod.yesterday()),
    new PeriodShortcut('7 dias', () => CostsPeriod.lastDays(7)),
    new PeriodShortcut('30 dias', () => CostsPeriod.lastDays(30)),
    new PeriodShortcut('este mês', () => CostsPeriod.thisMonth()),
    new PeriodShortcut('mês passado', () => CostsPeriod.lastMonth()),
  ];

  all(): ReadonlyArray<PeriodShortcut> {
    return PeriodShortcuts.ALL;
  }
}
